import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Logo } from 'components';
import { FirstViewLogoProps } from './FirstViewLogo.props';
import { BackImage, ContentImage, HeaderLogo, Image, QuoteContainer } from './FirstViewLogo.styles';

const FirstViewLogo = ({ loading, setLoading }: FirstViewLogoProps) => {
  const onLoadHandler = () => {
    setLoading(false);
  };

  return (
    <Box
      sx={{
        flexBasis: { xs: '100%' },
        maxWidth: { xs: '100%' },
        height: '100%',
        display: loading ? 'none' : 'flex',
        flexDirection: 'column',
      }}>
      <BackImage>
        <ContentImage>
          <Image alt="Background" src="/images/login-bg.jpg" onLoad={onLoadHandler} />
        </ContentImage>
        <HeaderLogo>
          <Typography variant="h1">
            <Link to="/">
              <Logo />
            </Link>
          </Typography>
        </HeaderLogo>
        <QuoteContainer>
          <Typography variant="h1">
            The leading
            <br />
            independent
          </Typography>
          <Typography variant="body1">valuation firm</Typography>
        </QuoteContainer>
      </BackImage>
    </Box>
  );
};

export default FirstViewLogo;
